import React from 'react';
import { roadmap } from '../data/plannedPages';
type RoadmapProps = {
  currentPhase: number;
  currentLabel: string;
};
export function Roadmap({
  currentPhase,
  currentLabel
}: RoadmapProps) {
  return <ol className="grid gap-px overflow-hidden rounded-2xl bg-paper/15 md:grid-cols-3" data-id="element-211" data-mp="14v5aklxjeh6q">
      {roadmap.map(step => {
      const active = step.phase === currentPhase;
      return <li key={step.phase} className={`flex flex-col p-6 md:p-8 ${active ? 'bg-signal' : 'bg-coal'}`} data-id="element-212" data-mp="uy90wcvwjp0l">
            <p className={`text-sm ${active ? 'text-paper/90' : 'text-paper/50'}`} data-id="element-213" data-mp="qvw44dz4v1fy">
              Phase {step.phase} · {step.status}
            </p>
            <p className="mt-2 font-display text-3xl uppercase" data-id="element-214" data-mp="lz5fv3d6czjg">{step.name}</p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-215" data-mp="gzj3ew567nbp">
              {step.pages.map(p => <li key={p} className={`rounded-full px-3 py-1 text-sm ${p === currentLabel ? 'bg-paper font-semibold text-ink' : active ? 'border border-paper/50' : 'border border-paper/20 text-paper/70'}`} data-id="element-216" data-mp="2gak5zla3l0zq">
                  {p}
                </li>)}
            </ul>
          </li>;
    })}
    </ol>;
}